import { render, staticRenderFns } from "./SmoltNew.vue?vue&type=template&id=6b7f2338"
import script from "./SmoltNew.vue?vue&type=script&lang=js"
export * from "./SmoltNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports